import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material';
import { AppLoaderComponent } from './loader.component';
@NgModule({
  declarations: [AppLoaderComponent],
  imports: [CommonModule, MatProgressBarModule],
  exports: [AppLoaderComponent],
})
export class LoaderModule { }
